import React from 'react';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';

export function PubpixelAd(props) {
  return (
    <div className="pubpixel d-none fixed-bottom">
      <AdUnit
        adName="pubpixel"
        position={'1'}
        all
        renderWhenViewable={false}
        refreshable={false}
        showLabel={false}
        refreshPageNavigationDisabled
        {...props}
      />
    </div>
  );
}
